import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialPayoutFilterData,
  InitialPayoutFilterDataVariables
} from "./types/InitialPayoutFilterData";
import { Payout, PayoutVariables } from "./types/Payout";
import { PayoutDetail, PayoutDetailVariables } from "./types/PayoutDetail";
import { PayoutScheduleLatest } from "./types/PayoutScheduleLatest";
import {
  PayoutStoreOrderDetails,
  PayoutStoreOrderDetailsVariables
} from "./types/PayoutStoreOrderDetails";
import {
  PayoutStoreOrders,
  PayoutStoreOrdersVariables
} from "./types/PayoutStoreOrders";
import {
  PayoutStoreOrdersDownload,
  PayoutStoreOrdersDownloadVariables
} from "./types/PayoutStoreOrdersDownload";
export const PayoutListQuery = gql`
  ${pageInfoFragment}
  query Payout(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: PayoutsFilterInput
  ) {
    payouts(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          coverage_end_date
          coverage_start_date
          payout_status
          generated_at
        }
      }
    }
  }
`;
export const usePayoutListQuery = makeBossQuery<Payout, PayoutVariables>(
  PayoutListQuery
);

const PayoutDetails = gql`
  query PayoutDetail($id: ID!) {
    payout(id: $id) {
      payout_status
    }
  }
`;
export const usePayoutDetail = makeBossQuery<
  PayoutDetail,
  PayoutDetailVariables
>(PayoutDetails);

export const initialPayoutsFilterDataQuery = gql`
  query InitialPayoutFilterData($mall: [ID], $brandId: [ID]) {
    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
    brands(first: 5, filter: { id: $brandId }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialPayoutFilterDataQuery = makeQuery<
  InitialPayoutFilterData,
  InitialPayoutFilterDataVariables
>(initialPayoutsFilterDataQuery);

export const payoutScheduleLatestQuery = gql`
  query PayoutScheduleLatest {
    payoutScheduleLatest {
      id
      schedule
      coverageDate {
        from
        to
      }
      jobStatus
    }
  }
`;

export const usePayoutScheduleLatestQuery = makeBossQuery<
  PayoutScheduleLatest,
  null
>(payoutScheduleLatestQuery);

const PayoutsStoreOrder = gql`
  query PayoutStoreOrderDetails($id: ID!) {
    payoutStoreOrder(id: $id) {
      id
      settlement_date
      settlement_status
      payment_fee_adjustment
      other_adjustment
      payout_date
      payable_status
    }
  }
`;
export const usePayoutStoreOrderDetails = makeBossQuery<
  PayoutStoreOrderDetails,
  PayoutStoreOrderDetailsVariables
>(PayoutsStoreOrder);

export const PayoutsStoreOrdersQuery = gql`
  ${pageInfoFragment}
  query PayoutStoreOrders(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: PayoutStoreOrdersFilterInput
  ) {
    payoutStoreOrders(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        node {
          id
          bank_account_name
          order_date
          completed_at
          store_order_code
          payment_method_type
          total_retail_price
          sale_discount_tenant
          sale_discount_sm
          sale_discount_total
          total_selling_price
          delivery_fee
          total_gross_transaction
          voucher_discount_tenant
          voucher_discount_sm
          voucher_discount_total
          price_paid
          payment_fee
          payment_fee_vat
          payment_fee_adjustment
          payment_fee_adjustment_vat
          total_payment_fee
          payment_fee_witholding_tax
          credit_card_witholding_tax
          other_adjustment
          net_settlement
          settlement_status
          settlement_date
          payable_status
        }
      }
    }
  }
`;

export const usePayoutsStoreOrdersQuery = makeBossQuery<
  PayoutStoreOrders,
  PayoutStoreOrdersVariables
>(PayoutsStoreOrdersQuery);

export const PayoutsStoreOrdersDownload = gql`
  ${pageInfoFragment}
  query PayoutStoreOrdersDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: PayoutStoreOrdersFilterInput
  ) {
    payoutStoreOrders(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        node {
          bank_account_name
          order_date
          completed_at
          store_order_code
          payment_method_type
          total_retail_price
          sale_discount_tenant
          sale_discount_sm
          sale_discount_total
          total_selling_price
          delivery_fee
          total_gross_transaction
          voucher_discount_tenant
          voucher_discount_sm
          voucher_discount_total
          price_paid
          payment_fee
          payment_fee_vat
          payment_fee_adjustment
          payment_fee_adjustment_vat
          total_payment_fee
          payment_fee_witholding_tax
          credit_card_witholding_tax
          other_adjustment
          net_settlement
          settlement_date
          company_name
          coverage_start_date
          coverage_end_date
          brand_name
          mall_name
          customer_code
          bank_account_no
        }
      }
    }
  }
`;

export const usePayoutsStoreOrdersDownload = makeBossQuery<
  PayoutStoreOrdersDownload,
  PayoutStoreOrdersDownloadVariables
>(PayoutsStoreOrdersDownload);
